import React, { useState } from "react"
import { graphql } from "gatsby"
import styled from "styled-components"
import {colors} from "../theme"

export const PanoramicImageWrapper = styled.div`
  width: 100%;
  padding: 3em 0;
  background-color: ${colors.background.Dark97}
`

export const PanoramicImageIframe = styled.iframe`
  width: 100%;
  aspect-ratio: 16/9;
  border: none;
  max-width: 60em;
  display: block;
  margin: 0 auto;
`

const PanoramicImage = (props) => {
  const {
    title,
    url,
  } = props

  return (
    <PanoramicImageWrapper>
      <PanoramicImageIframe src={url} allowfullscreen loading="lazy"></PanoramicImageIframe>
    </PanoramicImageWrapper>
  )
}

export default PanoramicImage

export const query = graphql`
  fragment PanoramicImage on ContentfulPanoramicImage {
    title
    url
  }
`
